var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "checkin-modal",
      attrs: {
        centered: "",
        id: "checkInModal",
        title: "Check-In",
        "hide-footer": "",
      },
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "spinner-container" },
            [_c("spinner-loader")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.guest || !_vm.guest.customer_id
        ? _c(
            "b-form",
            [
              _c("p", [
                _vm._v("A pre-authorized hold for the following amount"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hold-amount-input" },
                [
                  _c("currency-input", {
                    attrs: {
                      name: "Amount",
                      amount: _vm.amount,
                      fieldState: _vm.stateAmount,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.amount = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-3" }, [
                _vm._v("will be placed on the the following credit card"),
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mx-0 px-3 pr-4" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "pr-0 pt-1 card-label",
                      attrs: { xs: "12", sm: "3" },
                    },
                    [_vm._v("Card Number")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { xs: "12", sm: "9" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-card-number",
                          type: "number",
                          placeholder: "",
                          state: _vm.stateCardNumber,
                        },
                        on: {
                          keydown: (e) =>
                            _vm.onCheckMaxLength(
                              e,
                              _vm.cardForm.card_number,
                              16
                            ),
                        },
                        model: {
                          value: _vm.cardForm.card_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.cardForm, "card_number", $$v)
                          },
                          expression: "cardForm.card_number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-sm-3 mx-0 px-3 pr-4" },
                [
                  _c(
                    "b-col",
                    { staticClass: "card-label", attrs: { xs: "12", sm: "3" } },
                    [_vm._v("Exp Month")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "pt-1", attrs: { xs: "12", sm: "3" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-card-month",
                          type: "number",
                          placeholder: "",
                          state: _vm.stateCardExpMonth,
                        },
                        on: {
                          keydown: (e) =>
                            _vm.onCheckMaxLength(
                              e,
                              _vm.cardForm.card_exp_month,
                              2
                            ),
                        },
                        model: {
                          value: _vm.cardForm.card_exp_month,
                          callback: function ($$v) {
                            _vm.$set(_vm.cardForm, "card_exp_month", $$v)
                          },
                          expression: "cardForm.card_exp_month",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "card-label", attrs: { xs: "12", sm: "3" } },
                    [_vm._v("Exp Year")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "pt-1", attrs: { xs: "12", sm: "3" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-card-year",
                          type: "number",
                          placeholder: "",
                          state: _vm.stateCardExpYear,
                        },
                        on: {
                          keydown: (e) =>
                            _vm.onCheckMaxLength(
                              e,
                              _vm.cardForm.card_exp_year,
                              2
                            ),
                        },
                        model: {
                          value: _vm.cardForm.card_exp_year,
                          callback: function ($$v) {
                            _vm.$set(_vm.cardForm, "card_exp_year", $$v)
                          },
                          expression: "cardForm.card_exp_year",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-3" }, [
                _vm._v("The hold will be removed 24 hours after check-out"),
              ]),
            ],
            1
          )
        : _c(
            "b-form",
            [
              _c("p", [
                _vm._v("A pre-authorized hold for the following amount"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hold-amount-input" },
                [
                  _c("currency-input", {
                    attrs: {
                      name: "Amount",
                      amount: _vm.amount,
                      fieldState: _vm.stateAmount,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.amount = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mt-3" }, [
                _vm._v("will be placed on the following credit card"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "card-number h5 font-weight-bold" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.spacedCardNumber(_vm.customerCard)) +
                    "\n    "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-3" }, [
                _vm._v("The hold will be removed 24 hours after check-out"),
              ]),
              _vm._v(" "),
              _c(
                "b-collapse",
                {
                  staticClass: "mt-2",
                  attrs: {
                    id: "collapse-card-details",
                    visible: _vm.isAddCard,
                  },
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-row",
                            { staticClass: "mx-0" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pr-0 pt-1 card-label",
                                  attrs: { xs: "12", sm: "3" },
                                },
                                [_vm._v("Card Number")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { xs: "12", sm: "9" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-card-number",
                                      type: "number",
                                      placeholder: "",
                                      state: _vm.stateCardNumber,
                                    },
                                    on: {
                                      keydown: (e) =>
                                        _vm.onCheckMaxLength(
                                          e,
                                          _vm.cardForm.card_number,
                                          16
                                        ),
                                    },
                                    model: {
                                      value: _vm.cardForm.card_number,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cardForm,
                                          "card_number",
                                          $$v
                                        )
                                      },
                                      expression: "cardForm.card_number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-sm-3 mx-0" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "card-label",
                                  attrs: { xs: "12", sm: "3" },
                                },
                                [_vm._v("Exp Month")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "pt-1",
                                  attrs: { xs: "12", sm: "3" },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-card-month",
                                      type: "number",
                                      placeholder: "",
                                      state: _vm.stateCardExpMonth,
                                    },
                                    on: {
                                      keydown: (e) =>
                                        _vm.onCheckMaxLength(
                                          e,
                                          _vm.cardForm.card_exp_month,
                                          2
                                        ),
                                    },
                                    model: {
                                      value: _vm.cardForm.card_exp_month,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cardForm,
                                          "card_exp_month",
                                          $$v
                                        )
                                      },
                                      expression: "cardForm.card_exp_month",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "card-label",
                                  attrs: { xs: "12", sm: "3" },
                                },
                                [_vm._v("Exp Year")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "pt-1",
                                  attrs: { xs: "12", sm: "3" },
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "input-card-year",
                                      type: "number",
                                      placeholder: "",
                                      state: _vm.stateCardExpYear,
                                    },
                                    on: {
                                      keydown: (e) =>
                                        _vm.onCheckMaxLength(
                                          e,
                                          _vm.cardForm.card_exp_year,
                                          2
                                        ),
                                    },
                                    model: {
                                      value: _vm.cardForm.card_exp_year,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cardForm,
                                          "card_exp_year",
                                          $$v
                                        )
                                      },
                                      expression: "cardForm.card_exp_year",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mx-0 mt-2" },
        [
          _c(
            "b-col",
            { staticClass: "px-2", attrs: { xs: "4" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "my-2 px-0 w-100",
                  attrs: { variant: "danger" },
                  on: { click: _vm.onClickCancel },
                },
                [_vm._v("\n        Skip & Check-In\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-2", attrs: { xs: "4" } },
            [
              _vm.guest && _vm.guest.customer_id
                ? _c(
                    "b-button",
                    {
                      staticClass: "my-2 w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isAddCard = !_vm.isAddCard
                        },
                      },
                    },
                    [_vm._v("\n        New Card\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "px-2", attrs: { xs: "4" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "my-2 w-100",
                  attrs: { variant: "success" },
                  on: { click: _vm.onClickCheckIn },
                },
                [_vm._v("\n        Check-In\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }